/**
 * 本地存储
 */
export default {
  localStorage: {
    get(key) {
      if (!key) { return }
      const value = window.localStorage.getItem(key)
      return JSON.parse(value)
    },
    set(key, value) {
      if (!key) { return }
      window.localStorage.setItem(key, JSON.stringify(value))
    },
    remove(key) {
      if (!key) { return }
      window.localStorage.removeItem(key)
    }
  },
  sessionStorage: {
    get(key) {
      if (!key) { return }
      const value = window.sessionStorage.getItem(key)
      return JSON.parse(value)
    },
    set(key, value) {
      if (!key) { return }
      window.sessionStorage.setItem(key, JSON.stringify(value))
    },
    remove(key) {
      if (!key) { return }
      window.sessionStorage.removeItem(key)
    }
  }
}
